export default __webpack_public_path__ + "static/media/img-video-fix-supply.90f9a757.jpg";